import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { NavBarTab } from "./nav-bar-tab";

export const NavBarTabs = () => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="nav-bar__tabs">
      <NavBarTab path="public/leaderboard" label="leaderboard" />
      <NavBarTab path="/auction-list" label="Auction List" />
      <NavBarTab path="/auction-results" label="Auction Results" />
      <NavBarTab path="/rules" label="Rules" />
      <NavBarTab path="protected/profile" label="Profile" />
      {isAuthenticated && (
        <>
          <NavBarTab path="auth/protected" label="Protected" />
          <NavBarTab path="/admin" label="Admin" />
          <NavBarTab path="admin/sitevariables" label="Site Variables" />
          <NavBarTab path="admin/updateweek" label="Update Week" />
          <NavBarTab path="admin/team-admin" label="Team Admin" />
          <NavBarTab path="/score-breakdown" label="Score Breakdown" />
        </>
      )}
    </div>
  );
};
